import React, { useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Icon } from '@chakra-ui/react';
import routes from '../../../routes';
import { IoChevronDownSharp } from "react-icons/io5";

function SidebarLinks() {
  const [openSubmenus, setOpenSubmenus] = useState(null);
  const location = useLocation();
  const submenuRefs = useRef({});

  const toggleSubmenu = (menuName) => {
    setOpenSubmenus((prevOpenMenu) => (prevOpenMenu === menuName ? null : menuName));
  };

  const closeAllSubmenus = () => {
    setOpenSubmenus(null);
  };

  const isActive = (path) => location.pathname === path;

  const getSubmenuHeight = (menuName) => {
    if (submenuRefs.current[menuName]) {
      return submenuRefs.current[menuName].scrollHeight;
    }
    return 0;
  };

  return (
    <Box className="sidebar">
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {routes.map((route, index) => (
          <li key={index}>
            {route.children ? (
              <>
                {/* Parent Menu */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  cursor="pointer"
                  onClick={() => toggleSubmenu(route.name)}
                  p="2"
                >
                  <Box display="flex" alignItems="center">
                    {route.icon}
                    <span style={{ marginLeft: '10px' }}>{route.name}</span>
                  </Box>
                  <Icon
                    as={IoChevronDownSharp}
                    transition="transform 0.3s ease"
                    transform={openSubmenus === route.name ? 'rotate(-180deg)' : 'rotate(0deg)'}
                  />
                </Box>
                {/* Submenu */}
                <ul
                  ref={(el) => (submenuRefs.current[route.name] = el)}
                  style={{
                    listStyle: 'none',
                    margin: '5px 0 0 15px',
                    padding: 0,
                    maxHeight: openSubmenus === route.name ? `${getSubmenuHeight(route.name)}px` : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease',
                  }}
                >
                  {route.children.map((subRoute, subIndex) => (
                    <li key={subIndex} style={{ marginBottom: '10px' }}>
                      <Link
                        to={`${subRoute.layout}${subRoute.path}`}
                        style={{
                          textDecoration: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          color: isActive(`${subRoute.layout}${subRoute.path}`)
                            ? '#B78234'
                            : 'inherit',
                        }}                        
                      >
                        {subRoute.icon}
                        <span style={{ marginLeft: '10px' }}>{subRoute.name}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              // Regular menu item
              <Link
                to={`${route.layout}${route.path}`}
                style={{
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px',
                  color: isActive(`${route.layout}${route.path}`)
                    ? '#B78234'
                    : 'inherit',
                }}
                onClick={closeAllSubmenus}
                className="hover:text-theme-dark"
              >
                {route.icon}
                <span style={{ marginLeft: '10px' }}>{route.name}</span>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </Box>
  );
}

export default SidebarLinks;